export const environment = {
  production: false,
  useInMemory: false,
  apiUrl: '/api',
  googleClientId: '155155963212-n90giab62r597a99bkujcacml6l08264.apps.googleusercontent.com'
};
